import type React from 'react';

import { useWebclient } from '../../../../hooks/settings/webclients/useWebclient';
import { useWebclientActions } from '../../../../hooks/settings/webclients/useWebclientActions';
import type { WebclientFormData } from '../../../../interfaces/IWebclient';
import WebclientDataModal from './WebclientDataModal';

export const EditWebclientConfigModal: React.FC = () => {
  const { selectedWebclientConfig } = useWebclient();

  const { updateWebclientConfig } = useWebclientActions();

  // This is only happening if there is no any Webclient config on the Webclient settings page, so the system needs to apply the default Conversed config/style.
  // So in that case the user won't be able to open the 'WebclientDataModal', because there is no any config.
  if (!selectedWebclientConfig?.config || !selectedWebclientConfig?.name) {
    return null;
  }

  const onSave = (data: WebclientFormData) => {
    return updateWebclientConfig(
      selectedWebclientConfig.identifier,
      data.name,
      data.config,
    );
  };

  return (
    <WebclientDataModal
      data={selectedWebclientConfig?.config}
      name={selectedWebclientConfig?.name}
      onSubmit={onSave}
    />
  );
};

export default EditWebclientConfigModal;
